//  进入 - 出现
import APPEAR_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_appear_fill_light_24.svg';
//  进入 - 旋转
import ENTR_ROTATE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_rotate_fill_light_24.svg';
//  进入 - 缩放
import ENTR_SCALE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_zoom_fill_light_24.svg';
//  进入 - 基本缩放
import ENTR_BASIC_ZOOM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_basic_zoom_fill_light_24.svg';
//  进入 - 基本旋转
import ENTR_BASIC_SWIVEL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_basic_swivel_fill_light_24.svg';
//  进入 - 百叶窗
import ENTR_BLINDS_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_blinds_fill_light_24.svg';
//  进入 - 飞旋
import ENTR_BOOMERANG_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_boomerang_fill_light_24.svg';
//  进入 - 中心旋转
import ENTR_CENTER_REVOLVE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_center_revolve_fill_light_24.svg';
//  进入 - 字幕式
import ENTR_CREDITS_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_credits_fill_light_24.svg';
//  进入 - 淡入
import FADE_IN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_fade_in_fill_light_24.svg';
//  进入 - 浮入
import FLOAT_IN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_float_in_fill_light_24.svg';
//  进入 - 飞入
import FLY_IN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_fly_in_fill_light_24.svg';
//  进入 - 翻转式由远及近
import ENTR_GROW_TURN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_grow_turn_fill_light_24.svg';
//  进入 - 玩具风车
import ENTR_PINWHEEL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_pinwheel_fill_light_24.svg';
//  进入 - 升起
import RISE_UP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_rise_up_fill_light_24.svg';
//  进入 - 回旋
import ENTR_SPINNER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_spinner_light_24.svg';
//  进入 - 伸展
import ENTR_STRETCH_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_stretch_fill_light_24.svg';
//  进入 - 展开
import SPREAD_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_enter_spread_fill_light_24.svg';
// 进入_棋盘
import ENTR_CHECKERBOARD_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_chessboard_fill_light_24.svg';
// 进入_内向溶解：
import ENTR_DISSOLVE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_inward_dissolve_fill_light_24.svg';
// 进入_切入
import CUT_IN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_cut_in_fill_light_24.svg';
// 进入_随机线条
import ENTR_RANDOMBARS_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_random_bars_fill_light_24.svg';
// 进入_形状
import ENTR_SHAPE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_shape_fill_light_24.svg';
// 进入_劈裂
import ENTR_SPLIT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_split_fill_light_24.svg';
// 进入_阶梯
import ENTR_STRIPS_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_strips_fill_light_24.svg';
// 进入_楔入
import ENTR_WEDGE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_wedge_fill_light_24.svg';
// 进入_轮子
import ENTR_WHEEL_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_wheel_fill_light_24.svg';
// 进入_擦除
import ENTR_WIPE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_wipe_fill_light_24.svg';
// 进入_弹跳
import ENTR_BOUNCE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_bounce_fill_light_24.svg';
// 进入_曲线向上
import CURVE_UP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_upward_curve_fill_light_24.svg';
// 进入_掉落
import ENTR_FALL_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_fall_fill_light_24.svg';
// 进入_空翻
import ENTR_FLIP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_flip_fill_light_24.svg';
// 进入_浮动
import ENTR_FLOAT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_float_fill_light_24.svg';
// 进入_螺旋飞入
import SPIRAL_IN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_spiral_fly_in_fill_light_24.svg';
// 进入_挥鞭式
import ENTR_WHIP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_enter_whip_style_fill_light_24.svg';


// 强调 - 脉冲
import PULSE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_emphasis_pulse_fill_light_24.svg';
// 强调 - 陀螺旋
import ROTATE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_emphasis_swivel_fill_light_24.svg';
// 强调 - 透明
import EMPH_TRANSPARENCY_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_emphasis_transparency_fill_light_24.svg';
// 强调 - 放大/缩小
import SCALE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_emphasis_zoom_in_out_fill_light_24.svg';

// 强调 - 填充颜色
import FILL_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_fill_color_fill_light_24.svg';
// 强调 - 字体颜色
import FONT_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_font_color_fill_light_24.svg';
// 强调 - 线条颜色
import LINE_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_line_color_fill_light_24.svg';
// 强调 - 画笔颜色
import BRUSH_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_brush_color_fill_light_24.svg';
// 强调 - 补色
import COMPLEMENTARY_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_complementary_color_fill_light_24.svg';
// 强调 - 补色2
import COMPLEMENTARY_COLOR2_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_complementary_color2_fill_light_24.svg';
// 强调 - 对比色
import CONTRASTING_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_contrasting_color_fill_light_24.svg';
// 强调 - 加深
import DARKEN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_darken_fill_light_24.svg';
// 强调 - 不饱和
import DESATURATE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_desaturate_fill_light_24.svg';
// 强调 - 变淡
import LIGHTEN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_fade_fill_light_24.svg';
// 强调 - 对象颜色
import OBJECT_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_object_color_fill_light_24.svg';
// 强调 - 彩色脉冲
import COLOR_PULSE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_colorful_pulse_fill_light_24.svg';
// 强调 - 彩色延伸
import GROW_WITH_COLOR_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_colorful_extension_fill_light_24.svg';


//  退出 - 基本旋转
import EXIT_BASIC_SWIVEL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_basic_swivel_fill_light_24.svg';
// 退出 - 基本缩放
import EXIT_BASIC_ZOOM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_basic_zoom_fill_light_24.svg';
//  退出 - 百叶窗
import EXIT_BLINDS_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_blinds_fill_light_24.svg';
// 退出 - 飞旋
import EXIT_BOOMERANG_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_boomerang_fill_light_24.svg';
//  退出 - 中心旋转
import EXIT_CENTER_REVOLVE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_center_revolve_fill_light_24.svg';
// 退出 - 层叠
import EXIT_COLLAPSE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_collapse_fill_light_24.svg';
//  退出 - 收缩
import EXIT_SPREAD_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_contract_fill_light_24.svg';
// 退出 - 字幕式
import EXIT_CREDITS_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_credits_fill_light_24.svg';
//  退出 - 消失
import DISAPPEAR_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_disappear_fill_light_24.svg';
// 退出 - 淡出
import FADE_OUT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_fade_out_fill_light_24.svg';
//  退出 - 浮出
import FLOAT_OUT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_float_out_fill_light_24.svg';
// 退出 - 飞出
import FLY_OUT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_fly_out_fill_light_24.svg';
//  退出 - 玩具风车
import EXIT_PINWHEEL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_pinwheel_fill_light_24.svg';
// 退出 - 旋转
import EXIT_ROTATE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_rotate_fill_light_24.svg';
//  退出 - 收缩并旋转
import EXIT_SHRINK_TURN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_shrink_turn_fill_light_24.svg';
// 退出 - 下沉
import EXIT_SINK_DOWN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_sink_down_fill_light_24.svg';
// 退出 - 回旋
import EXIT_SPINNER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_spinner_fill_light_24.svg';
// 退出 - 伸展
import EXIT_STRETCH_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_stretch_fill_light_24.svg';
// 退出 - 缩放
import EXIT_SCALE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_zoom_fill_light_24.svg';
// 退出_棋盘
import EXIT_CHECKERBOARD_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_chessboard_fill_light_24.svg';
// 退出_向外溶解
import EXIT_DISSOLVE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_outward_dissolve_fill_light_24.svg';
// 退出_切出
import CUT_OUT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_cut_out_fill_light_24.svg';
// 退出_随机线条
import EXIT_RANDOMBARS_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_random_bars_fill_light_24.svg';
// 退出_形状
import EXIT_SHAPE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_shape_fill_light_24.svg';
// 退出_劈裂
import EXIT_SPLIT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_split_fill_light_24.svg';
// 退出_阶梯状
import EXIT_STRIPS_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_strips_fill_light_24.svg';
// 退出_楔入
import EXIT_WEDGE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_wedge_fill_light_24.svg';
// 退出_轮子
import EXIT_WHEEL_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_wheel_fill_light_24.svg';
// 退出_擦除
import EXIT_WIPE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_wipe_fill_light_24.svg';
// 退出_弹跳
import EXIT_BOUNCE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_bounce_fill_light_24.svg';
// 退出_向下曲线
import CURVE_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_downward_curve_fill_light_24.svg';
// 退出_掉落
import EXIT_FALL_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_fall_fill_light_24.svg';
// 退出_空翻
import EXIT_FLIP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_flip_fill_light_24.svg';
// 退出_浮动
import EXIT_FLOAT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_float_fill_light_24.svg';
// 退出_螺旋飞出
import SPIRAL_OUT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_spiral_fly_out_fill_light_24.svg';
// 退出_挥鞭式
import EXIT_WHIP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_animation_exit_whip_style_fill_light_24.svg';


// 路径 - 弧形
import ARC_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_arc_fill_light_24.svg';
// 路径 - 直线
import STRAIGHT_LINE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_line_fill_light_24.svg';
// 路径 -循环
import CYCLE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_cycle_fill_light_24.svg';
// 路径 - 形状
import SHAPE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_shape_fill_light_24.svg';
// 路径 - 转弯
import TURN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_turn_fill_light_24.svg';
// 路径 - 自定义
import CUSTOM_PATH_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_animation_path_custom_fill_light_24.svg';

// 预览
import ANIM_PTREVIEW_ICON from '@tencent/docs-design-resources/icon/desktop/svg/view_light_24.svg';
// 动画刷
import ANIM_BRUSH_ICON from '@tencent/docs-design-resources/icon/desktop/svg/animation_brush_light_24.svg';
// 持续时间
import DURATION_ICON from '@tencent/docs-design-resources/icon/mobile/svg/time_outline_regular_24.svg';
// 下拉箭头
import ARROW_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/arrowhead_down_12.svg';
// 播放
import START_ICON from '@tencent/docs-design-resources/pc/svg/start_outline_light_24.svg';
// 延迟
import DELAY_ICON from '@tencent/docs-design-resources/pc/svg/delay_outline_light_24.svg';
// 触发器
import TRIGGER_ICON from '@tencent/docs-design-resources/pc/svg/trigger_outline_light_24.svg';
// 动画窗格
import ANIM_PANE_ICON from '@tencent/docs-design-resources/pc/svg/animation_pane_outline_light_24.svg';


export {
    ANIM_PANE_ICON,
    TRIGGER_ICON,
    DELAY_ICON,
    START_ICON,
    PULSE_ICON,
    ROTATE_ICON,
    EMPH_TRANSPARENCY_ICON,
    SCALE_ICON,
    APPEAR_ICON,
    ENTR_ROTATE_ICON,
    ENTR_SCALE_ICON,
    ENTR_BASIC_ZOOM_ICON,
    ENTR_BASIC_SWIVEL_ICON,
    ENTR_BLINDS_ICON,
    ENTR_BOOMERANG_ICON,
    ENTR_CENTER_REVOLVE_ICON,
    ENTR_CREDITS_ICON,
    FADE_IN_ICON,
    FLOAT_IN_ICON,
    FLY_IN_ICON,
    ENTR_GROW_TURN_ICON,
    ENTR_PINWHEEL_ICON,
    RISE_UP_ICON,
    ENTR_SPINNER_ICON,
    SPREAD_ICON,
    ENTR_STRETCH_ICON,
    ENTR_CHECKERBOARD_ICON,
    ENTR_DISSOLVE_ICON,
    CUT_IN_ICON,
    ENTR_RANDOMBARS_ICON,
    ENTR_SHAPE_ICON,
    ENTR_SPLIT_ICON,
    ENTR_STRIPS_ICON,
    ENTR_WEDGE_ICON,
    ENTR_WHEEL_ICON,
    ENTR_WIPE_ICON,
    ENTR_BOUNCE_ICON,
    CURVE_UP_ICON,
    ENTR_FALL_ICON,
    ENTR_FLIP_ICON,
    ENTR_FLOAT_ICON,
    SPIRAL_IN_ICON,
    ENTR_WHIP_ICON,
    EXIT_BASIC_SWIVEL_ICON,
    EXIT_SCALE_ICON,
    EXIT_BASIC_ZOOM_ICON,
    EXIT_BLINDS_ICON,
    EXIT_BOOMERANG_ICON,
    EXIT_CENTER_REVOLVE_ICON,
    EXIT_COLLAPSE_ICON,
    EXIT_SPREAD_ICON,
    EXIT_CREDITS_ICON,
    DISAPPEAR_ICON,
    FADE_OUT_ICON,
    FLOAT_OUT_ICON,
    FLY_OUT_ICON,
    EXIT_PINWHEEL_ICON,
    EXIT_ROTATE_ICON,
    EXIT_SHRINK_TURN_ICON,
    EXIT_SINK_DOWN_ICON,
    EXIT_SPINNER_ICON,
    EXIT_STRETCH_ICON,
    EXIT_CHECKERBOARD_ICON,
    CUT_OUT_ICON,
    EXIT_DISSOLVE_ICON,
    EXIT_RANDOMBARS_ICON,
    EXIT_SHAPE_ICON,
    EXIT_SPLIT_ICON,
    EXIT_STRIPS_ICON,
    EXIT_WEDGE_ICON,
    EXIT_WHEEL_ICON,
    EXIT_WIPE_ICON,
    EXIT_BOUNCE_ICON,
    CURVE_DOWN_ICON,
    EXIT_FALL_ICON,
    EXIT_FLIP_ICON,
    EXIT_FLOAT_ICON,
    SPIRAL_OUT_ICON,
    EXIT_WHIP_ICON,
    ARC_ICON,
    STRAIGHT_LINE_ICON,
    CYCLE_ICON,
    SHAPE_ICON,
    TURN_ICON,
    CUSTOM_PATH_ICON,
    ANIM_PTREVIEW_ICON,
    ANIM_BRUSH_ICON,
    DURATION_ICON,
    ARROW_DOWN_ICON,
    FILL_COLOR_ICON,
    FONT_COLOR_ICON,
    LINE_COLOR_ICON,
    BRUSH_COLOR_ICON,
    COMPLEMENTARY_COLOR_ICON,
    COMPLEMENTARY_COLOR2_ICON,
    CONTRASTING_COLOR_ICON,
    DARKEN_ICON,
    DESATURATE_ICON,
    LIGHTEN_ICON,
    OBJECT_COLOR_ICON,
    COLOR_PULSE_ICON,
    GROW_WITH_COLOR_ICON,
};
